import { render, staticRenderFns } from "./Page10.vue?vue&type=template&id=287222ca&scoped=true&"
import script from "./Page10.vue?vue&type=script&lang=ts&"
export * from "./Page10.vue?vue&type=script&lang=ts&"
import style0 from "./Page10.vue?vue&type=style&index=0&id=287222ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287222ca",
  null
  
)

export default component.exports